import { useMutation, useQueryClient } from '@tanstack/react-query';

import { enableMfa } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-151, AC-2: подтверждение enrollment первым TOTP-кодом.
export function useMfaEnable() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (totpCode: string) => enableMfa(totpCode),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
